module.exports = __webpack_public_path__ + "static/media/asombrado-phone.56e95c08.svg";